@if (visible && buildings.length > 0) {
  <div class="building-selector-container">
    <nb-select
      [multiple]="true"
      [placeholder]="'All buildings' | translate"
      [ngModel]="displaySelection"
      (ngModelChange)="onDisplaySelectionChange($event)"
      class="building-select"
    >
      @if (showAllOption) {
        <nb-option [value]="ALL_OPTION_VALUE" [disabled]="hasDisabledBuildings">{{ 'All buildings' | translate }}</nb-option>
      }
      @for (building of buildings; track building.id) {
        <nb-option
          [value]="building.buildingId"
          [disabled]="building.disabled"
        >
          {{ building.name }}
        </nb-option>
      }
    </nb-select>
  </div>
}
